import { callRequest } from '../../helpers/callRequest';
import { autofillParams } from './autofillParams';
export const getUseWrappedMutation = ({ request, getAutofill, getUseMutation, }) => {
    const useMutation = getUseMutation();
    const mutationFn = (params) => {
        const autofilledParams = autofillParams(params, getAutofill);
        return callRequest(request, autofilledParams);
    };
    const useWrappedMutation = (mutationOptions) => {
        return useMutation({
            mutationFn,
            ...mutationOptions,
        });
    };
    return useWrappedMutation;
};
